import { createSlice } from "@reduxjs/toolkit"

const landingPagesSlice = createSlice({
  name: "landingPages",
  initialState: {
    landingPages: null,
    getAllLandingPagesLoading: false,
    updateLandingPageUrlLoading: false,
    createLandingPageUrlLoading: false,
  },
  reducers: {
    getAllLandingPagesLoading: (state) => {
      state.getAllLandingPagesLoading = true
    },
    getAllLandingPagesSuccess: (state, action) => {
      state.landingPages = action.payload
      state.getAllLandingPagesLoading = false
    },
    getAllLandingPagesFailure: (state) => {
      state.getAllLandingPagesLoading = false
    },
    updateLandingPageUrlLoading: (state) => {
      state.updateLandingPageUrlLoading = true
    },
    updateLandingPageUrlSuccess: (state) => {
      state.updateLandingPageUrlLoading = false
    },
    updateLandingPageUrlFailure: (state) => {
      state.updateLandingPageUrlLoading = false
    },
    createLandingPageUrlLoading: (state) => {
      state.createLandingPageUrlLoading = true
    },
    createLandingPageUrlSuccess: (state, action) => {
      // state.landingPages = [...state.landingPages, action.payload]
      state.createLandingPageUrlLoading = false
    },
    createLandingPageUrlFailure: (state) => {
      state.createLandingPageUrlLoading = false
    },
  },
})

export const {
  getAllLandingPagesLoading,
  getAllLandingPagesSuccess,
  getAllLandingPagesFailure,
  updateLandingPageUrlLoading,
  updateLandingPageUrlSuccess,
  updateLandingPageUrlFailure,
  createLandingPageUrlLoading,
  createLandingPageUrlSuccess,
  createLandingPageUrlFailure,
} = landingPagesSlice.actions

export default landingPagesSlice.reducer
